export function isLayerSelector(property) {
    return property.substr(0, 6) === '@layer';
}
//# sourceMappingURL=isLayerSelector.js.map